import { CheckboxGroup, VStack, Checkbox } from '@chakra-ui/react';
import { useState, useEffect,useRef } from 'react'
import { Controller } from "react-hook-form";
// import { errorHandle } from '../../api/api';
import { getAllDocuments } from '../../classes/Document'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'
import { useToast } from '@chakra-ui/react'

const CheckboxScanDocument = ({ control, watch }) => {
    const [list, setList] = useState([])
    const toast = useToast()
    const loadData = useRef()
    
    loadData.current = async () => {
        await getAllDocuments()
            .then(res => {
                if (res) {
                    setList(res)
                }
            })
            .catch(error => {
                // console.log('error')
                // console.log(errorHandle(error))
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    useEffect(() => {
        loadData.current()
    }, [])

    return (
        <Controller
            name="scan_document_list"
            control={control}
            render={({field}) => (
                <CheckboxGroup defaultValue={field.value} {...field}>
                    <VStack align="start">
                        {
                            list.length > 0 &&
                            list.map(item => <Checkbox value={`${item.id}`} key={`checkbox_doc_${item.id}`} isReadOnly={item.id <= 2}>{item.name}</Checkbox>)
                        }
                    </VStack>
                </CheckboxGroup>
            )}
        />

    )
}

export default CheckboxScanDocument
